import { DocumentUriConstant } from 'src/constants';
import { MButton, MModalBody, MModalFooter, MModalTitle, MTypography, SecAndTafFeesDescription } from 'src/lib';
import { BaseStyle } from 'src/styles';

interface TradeSecurityHoldingModalServiceFeeStepProps {
  onBack: () => void;
}

export const TradeSecurityHoldingModalServiceFeeStep = ({ onBack }: TradeSecurityHoldingModalServiceFeeStepProps) => {
  return (
    <>
      <MModalTitle>Service Fee</MModalTitle>
      <MModalBody>
        <MTypography variant='body1'>
          My IPO sign up is free and there are no associated membership fees to maintain a non-retirement account. For
          all retirement accounts, we pass on an annual custodial fee of $45.00. You are not charged any fees when you
          invest in a My IPO offer. For publicly traded securities, should you buy shares in the open market (outside of
          an offering) or sell shares in the future, we charge a $10 commission if you enter a trade online, or 1% of
          trade value plus $10 commission if you call our Trade Desk to enter trade on your behalf. We also pass along
          certain regulatory fees, such as SEC and TAF fees. To view other fees, please review the{' '}
          <a href={DocumentUriConstant.MY_IPO_FEE_SCHEDULE} target='_blank' rel='noopener noreferrer'>
            My IPO Fee Schedule
          </a>
          .
          <br />
          <br />
          IMPORTANT NOTE: For non-public securities there may be no liquidity, limited liquidity and redemption fees may
          apply if redeemed before maturity as outlined in each offering prospectus.
          <br />
          <br />
          <SecAndTafFeesDescription />
        </MTypography>
      </MModalBody>
      <MModalFooter className={BaseStyle.levelRight}>
        <MButton type='tertiary' onClick={onBack}>
          Back
        </MButton>
      </MModalFooter>
    </>
  );
};
